import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";
import qs from "qs";

const SchoolService = {};

SchoolService.getAcademicYear = function (params) {
  return fetch({
    url: ApiConstant.GET_ACADEMIC_YEAR,
    method: "get",
    params,
  });
};
SchoolService.getRecentAcademicYear = function (params) {
  return fetch({
    url: ApiConstant.GET_RECENT_ACADEMIC_YEAR,
    method: "get",
    params: Utils.filterHeaderParams(params),
    paramsSerializer: (params) =>
      qs.stringify(params, {
        arrayFormat: "repeat",
      }),
  });
};
SchoolService.getAcademicYear = function (params) {
  return fetch({
    url: ApiConstant.GET_ACADEMIC_YEAR,
    method: "get",
    params,
  });
};
SchoolService.downalodExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.ACADEMIC_YEAR_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};
SchoolService.getSingleAcademicYear = function (id) {
  return fetch({
    url: ApiConstant.GET_SINGLE_ACADEMIC_YEAR,
    params: Utils.filterHeaderParams({aca_id: id}),
    method: "get",
  });
};
SchoolService.updateAcademicYearStatus = function (status, academic_year_id) {
  console.log("academic_year_id", status);

  return fetch({
    url: `${ApiConstant.UPDATE_ACADEMIC_YEAR_STATUS}/${academic_year_id?.academic_year_id}`,
    method: "patch",
    data: {
      status: status?.status,
    },
  });
};
SchoolService.updateBulkAcademicYearStatus = function (data) {
  const payload = {
    status: data?.data?.status,
    ids: Array.isArray(data?.data?.data)
      ? data?.data?.data
      : [data?.data?.data],
  };
  return fetch({
    url: ApiConstant.UPDATE_BULK_ACADEMIC_YEAR_STATUS,
    method: "patch",
    data: payload,
  });
};
SchoolService.addAcademicYear = function (data) {
  return fetch({
    url: ApiConstant.ADD_ACADEMIC_YEAR,
    method: "post",
    data,
  });
};
SchoolService.editAcademicYear = function (id, data) {
  return fetch({
    url: `${ApiConstant.EDIT_ACADEMIC_YEAR}${id}`,
    method: "patch",
    data,
  });
};

SchoolService.getSchool = function (params) {
  return fetch({
    url: ApiConstant.SCHOOL_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
    paramsSerializer: (params) =>
      qs.stringify(params, {
        arrayFormat: "repeat",
      }),
  });
};

SchoolService.getPackageList = function (params) {
  return fetch({
    url: ApiConstant.SCHOOL_PACKAGE_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
SchoolService.studentInviteData = function (params) {
  return fetch({
    url: ApiConstant.STUDENT_INVITE_DATA,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
SchoolService.updatePackageList = function (data) {
  return fetch({
    url: ApiConstant.UPDATE_SCHOOL_PACKAGE_LIST,
    method: "patch",
    data,
  });
};
SchoolService.updateBasePriceList = function (data) {
  return fetch({
    url: ApiConstant.UPDATE_BASE_PRICE,
    method: "patch",
    data,
  });
};

SchoolService.getPromoCodeList = function (params) {
  return fetch({
    url: ApiConstant.GET_PROMO_CODE_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
SchoolService.getSinglePromo = function (params) {
  return fetch({
    url: ApiConstant.GET_SINGLE_PROMO,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};

SchoolService.addPromoCode = function (data) {
  return fetch({
    url: ApiConstant.ADD_PROMO_CODE,
    method: "post",
    data,
  });
};
SchoolService.editPromoCode = function (data) {
  return fetch({
    url: ApiConstant.EDIT_PROMO_CODE,
    method: "patch",
    data,
  });
};

SchoolService.downalodSchoolExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.SCHOOL_EXCEL_DOWNLAOD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};
SchoolService.getSingleSchool = function (params) {
  return fetch({
    url: ApiConstant.GET_SINGLE_SCHOOL,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
SchoolService.updateSchoolStatus = function (data) {
  const payload = {
    id: data.params.id,
    status: data.data.status,
  };
  return fetch({
    url: ApiConstant.UPDATE_SCHOOL_STATUS,
    method: "patch",
    data: payload,
  });
};
SchoolService.addSchoolGroup = function (data) {
  return fetch({
    url: ApiConstant.ADD_SCHOOL_GROUP,
    method: "post",
    data,
  });
};
SchoolService.getSchoolGroup = function (params) {
  return fetch({
    url: ApiConstant.GET_SCHOOL_GROUP_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
    paramsSerializer: (params) =>
      qs.stringify(params, {
        arrayFormat: "repeat",
      }),
  });
};
SchoolService.addSchool = function (data, params) {
  // const fomrData = Utils.toFormData(data);
  return fetch({
    url: ApiConstant.ADD_SCHOOL,
    method: "post",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
SchoolService.EditSchool = function (data, params) {
  return fetch({
    url: ApiConstant.EDIT_SCHOOL,
    method: "patch",
    data,
    params: Utils.filterHeaderParams(params),
  });
};
SchoolService.deleteLinkStudent = function (data) {
  return fetch({
    url: ApiConstant.DELETE_PROMO_LINK_STUDENT,
    method: "delete",
    data,
  });
};
SchoolService.updateBulkSchoolStatus = function (data, status) {
  const payload = {
    status: status,
    ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.SCHOOL_BULK_STATUS_UPDATE,
    method: "patch",
    data: payload,
  });
};
export default SchoolService;
